export default "__VITE_ASSET__D532EcCZ__"